import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Organization, Pageable } from '@nimmsta/ng-commons-lib/models';
import {
  SFSOptions,
  WorkflowDataService,
} from '@nimmsta/ng-commons-lib/data-access';
import { AdminJob } from '../models/adminJob';

@Injectable({
  providedIn: 'root',
})
export class JobAdminService extends WorkflowDataService<AdminJob> {
  public selectedOrgs: Organization[] = [];

  protected override get apiEndpoint(): string {
    return '/jobs/admin';
  }

  override list(
    options: Partial<SFSOptions> = {},
  ): Observable<Pageable<AdminJob>> {
    let params = this.getParams(options);
    params = this.addOrgsToParams(params);
    return this.http.get<Pageable<AdminJob>>(this.baseUrl + this.apiEndpoint, {
      params,
    });
  }

  private addOrgsToParams(params: HttpParams): HttpParams {
    if (this.selectedOrgs && this.selectedOrgs.length > 0) {
      params = params.append(
        'organizations',
        this.selectedOrgs.map((org) => org.id).join(','),
      );
    }
    return params;
  }
}
